import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { API_BASE_URL } from './api/config';
import { FloatingCall } from './components/Layout';
import HomePage from './pages/HomePage';
import ResultsPage from './pages/ResultsPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import DownloadsPage from './pages/DownloadsPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import MaintenancePage from './pages/MaintenancePage';
import { IconSpinner } from './components/Icons';

export default function App() {
  const [publicCfg, setPublicCfg] = useState({ loading: true, maintenance: false, maintenance_message: '' });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await fetch(`${API_BASE_URL}/public-config`);
        const j = await r.json().catch(() => ({}));
        if (!alive) return;
        setPublicCfg({
          loading: false,
          maintenance: Boolean(j?.maintenance),
          maintenance_message: String(j?.maintenance_message || ''),
        });
      } catch (_) {
        if (alive) setPublicCfg({ loading: false, maintenance: false, maintenance_message: '' });
      }
    })();
    return () => { alive = false; };
  }, []);

  if (publicCfg.loading) {
    return (
      <div className="min-h-screen bg-parchment flex items-center justify-center">
        <IconSpinner className="w-10 h-10 text-forest" />
      </div>
    );
  }

  if (publicCfg.maintenance) {
    return <MaintenancePage message={publicCfg.maintenance_message} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-failure" element={<PaymentFailurePage />} />
        <Route path="/downloads" element={<DownloadsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
      <FloatingCall />
    </BrowserRouter>
  );
}
